import clsx from 'clsx'
import React from 'react'
import { Controller } from 'react-hook-form'

import s from './styles.module.scss'

import { ControlledCommons } from '../../atoms/fields/common.interface'
import Icon from '../../atoms/icons/icon'

export interface InputColorProps extends ControlledCommons {
  disabled?: boolean
  placeholder?: string

  showEditIcon?: boolean
}

const InputColor: React.FC<InputColorProps> = ({
  control,
  name,
  rules,
  disabled = false,
  placeholder,
  showEditIcon = false,
}) => {
  const inputColorRef = React.useRef<HTMLInputElement>(null)

  const handleClickIcon = () => {
    if (inputColorRef.current) {
      inputColorRef.current.click()
    }
  }

  return (
    <Controller
      control={control}
      name={name}
      rules={{
        ...rules,
        validate: (value) => {
          const hexRegex = /^#([0-9A-Fa-f]{6})$/

          if (hexRegex.test(value) || !value) {
            return true
          }

          return 'Veuillez entrer une couleur HEX valide, e.g. #FFFFFF'
        },
      }}
      render={({ field, fieldState: { error } }) => {
        return (
          <div className={s.renderContainer}>
            <div className={clsx(s.render, { [s.disabled]: disabled })}>
              <input
                ref={field.ref}
                disabled={disabled}
                type='text'
                placeholder={placeholder}
                className={s.renderTextInput}
                value={field.value ?? ''}
                onChange={field.onChange}
                onBlur={field.onBlur}
              />
              <div className={s.renderColorInputContainer}>
                <input
                  ref={inputColorRef}
                  disabled={disabled}
                  type='color'
                  className={s.renderColorInput}
                  value={field.value ?? '#f3f4f5'}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                />
              </div>

              {showEditIcon && (
                <button className={s.renderIcon} onClick={handleClickIcon}>
                  <Icon name='edit' size={14} />
                </button>
              )}
            </div>
            {error?.message && (
              <span className={s.renderError}>{error.message}</span>
            )}
          </div>
        )
      }}
    />
  )
}

export default InputColor
